import { Money, SupplierSummaryEnrollmentStatus } from './models';

export class SellerSummaryGQL {
    public sellerSummaryKey: string;
    public name: string;
    public earlyPaidAmount: Money;
    public enrollmentStatus: SupplierSummaryEnrollmentStatus;
    public openInvoiceAmount: Money;
    public flexTermAmount: Money;
    public flexTermPercentUsed: number;
    public earlyPaidPercentUsed: number;
    public feeShare: number;
    public percentUsed: number;
    public sellerId: string;
    public buyerName: string;
    public sellerKey: string;
    public buyerKey: string;
    public totalPaidFees: Money;
    public buyerPaidEarlyPaymentFeePercentageVisible: boolean;

    constructor(obj?: Partial<SellerSummaryGQL>) {
        this.sellerSummaryKey = obj?.sellerSummaryKey ?? this.sellerSummaryKey;
        this.name = obj?.name ?? this.name;
        this.earlyPaidAmount = obj?.earlyPaidAmount ?? this.earlyPaidAmount;
        this.enrollmentStatus = obj?.enrollmentStatus ?? this.enrollmentStatus;
        this.openInvoiceAmount = obj?.openInvoiceAmount ?? this.openInvoiceAmount;
        this.flexTermAmount = obj?.flexTermAmount ?? this.flexTermAmount;
        this.flexTermPercentUsed = obj?.flexTermPercentUsed ?? this.flexTermPercentUsed;
        this.earlyPaidPercentUsed = obj?.earlyPaidPercentUsed ?? this.earlyPaidPercentUsed;
        this.feeShare = obj?.feeShare ?? this.feeShare;
        this.percentUsed = obj?.percentUsed ?? this.percentUsed;
        this.sellerId = obj?.sellerId ?? this.sellerId;
        this.buyerName = obj?.buyerName ?? this.buyerName;
        this.sellerKey = obj?.sellerKey ?? this.sellerKey;
        this.buyerKey = obj?.buyerKey ?? this.buyerKey;
        this.totalPaidFees = obj?.totalPaidFees ?? this.totalPaidFees;
        this.buyerPaidEarlyPaymentFeePercentageVisible =
            obj?.buyerPaidEarlyPaymentFeePercentageVisible ??
            this.buyerPaidEarlyPaymentFeePercentageVisible;
    }
}
